import { render, staticRenderFns } from "./VNotification.vue?vue&type=template&id=987b259e&scoped=true"
import script from "./VNotification.vue?vue&type=script&lang=js"
export * from "./VNotification.vue?vue&type=script&lang=js"
import style0 from "./VNotification.vue?vue&type=style&index=0&id=987b259e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987b259e",
  null
  
)

export default component.exports